/**
 * 平台统一确认 / 提示弹窗（基于 Element UI MessageBox + 自定义样式）
 */
import { Message, MessageBox } from 'element-ui'

export const APP_MSGBOX_CLASS = 'app-msgbox'

const TOAST_DURATION = 3200

const BASE_OPTIONS = {
  customClass: APP_MSGBOX_CLASS,
  confirmButtonText: '确定',
  cancelButtonText: '取消',
  closeOnClickModal: false,
  closeOnPressEscape: true,
  distinguishCancelAndClose: true,
}

/**
 * @param {string} message
 * @param {string} [title='提示']
 * @param {object} [options]
 * @returns {Promise<void>}
 */
export function appConfirm(message, title = '提示', options = {}) {
  return MessageBox.confirm(String(message || ''), String(title || '提示'), {
    ...BASE_OPTIONS,
    ...options,
  })
}

/**
 * 危险操作确认（删除等）
 * @param {string} message
 * @param {string} [title='确认删除']
 * @param {object} [options]
 * @returns {Promise<void>}
 */
export function appConfirmDelete(message, title = '确认删除', options = {}) {
  return appConfirm(message, title, {
    type: 'warning',
    confirmButtonText: '删除',
    confirmButtonClass: 'app-msgbox-btn--danger',
    ...options,
  })
}

/**
 * @param {string} message
 * @param {string} [title='提示']
 * @param {object} [options]
 * @returns {Promise<void>}
 */
export function appAlert(message, title = '提示', options = {}) {
  return MessageBox.alert(String(message || ''), String(title || '提示'), {
    ...BASE_OPTIONS,
    showCancelButton: false,
    ...options,
  })
}

/** 轻提示（替代原生 alert，用于校验 / 操作反馈） */
export function toastWarning(message) {
  Message.warning({ message: String(message || ''), duration: TOAST_DURATION })
}

export function toastError(message) {
  Message.error({ message: String(message || ''), duration: TOAST_DURATION + 800 })
}

export function toastSuccess(message) {
  Message.success({ message: String(message || ''), duration: TOAST_DURATION })
}

export function toastInfo(message) {
  Message.info({ message: String(message || ''), duration: TOAST_DURATION })
}

export function installAppDialog(Vue) {
  Vue.prototype.$appConfirm = appConfirm
  Vue.prototype.$appConfirmDelete = appConfirmDelete
  Vue.prototype.$appAlert = appAlert
  Vue.prototype.$toastWarning = toastWarning
  Vue.prototype.$toastError = toastError
  Vue.prototype.$toastSuccess = toastSuccess
  Vue.prototype.$toastInfo = toastInfo
}
